import React from 'react';
import './PriceTicker.css';

const PriceTicker = () => {
  // This data will eventually come from your Flask API
  const cropData = [
    { name: 'Wheat', location: 'Punjab', price: 2125, change: 15.50, changePercent: 0.73 },
    { name: 'Rice', location: 'Andhra Pradesh', price: 1940, change: -5.00, changePercent: -0.26 },
    { name: 'Cotton', location: 'Gujarat', price: 8500, change: 50.00, changePercent: 0.59 },
    { name: 'Sugarcane', location: 'Uttar Pradesh', price: 350, change: 2.00, changePercent: 0.57 },
    { name: 'Soybean', location: 'Madhya Pradesh', price: 5200, change: -25.00, changePercent: -0.48 },
  ];

  // For a seamless animation, we render the list twice
  const duplicatedCropData = [...cropData, ...cropData];

  return (
    <div className="price-ticker-container">
      {/* 1. The new fixed header */}
      <div className="ticker-header">
        EXPLORE<br />CROP<br />PRICES
      </div>

      {/* This wrapper is essential for the scrolling animation */}
      <div className="ticker-wrap">
        <div className="ticker-content">
          {duplicatedCropData.map((crop, index) => (
            <div key={index} className="ticker-item">
              <h3>{crop.name} - {crop.location}</h3>
              {/* 2. Price and Change are now in a single container */}
              <div className="price-info">
                <p className="price">₹{crop.price.toLocaleString()}</p>
                <p className={`change ${crop.change >= 0 ? 'positive' : 'negative'}`}>
                  {crop.change >= 0 ? '↑' : '↓'} {Math.abs(crop.change).toFixed(2)} ({crop.changePercent}%)
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PriceTicker;